<div class="flex flex-col">

  <div class="flex justify-center items-center">
    <particle-file-selector [(file)]="fileToUpload" class="flex flex-col full-grow-no-shrink-no-basis"
                            [legend]="'Select a document for translation (.DOC, .XLSX, .PDF)'"
                            [required]="true" flxLyout="row"
                            (change)="handleFileInput()">
    </particle-file-selector>

  </div>
  <div *ngIf="!isCheckFileFormat" style="color:red" class="flex flex-row"><label>Invalid File Type(Accepted Format:
    Pdf).</label><span>*</span></div>

  <div class="notification-message-container m-0 m-t-10 m-b-20">

    <ul class="p-0 p-l-20">
      <li>You can upload Word, Excel or PDF documents for translation</li>
      <li>For best translation results, upload either a Word or Excel document</li>
      <li>Documents can be up to 60 pages for non-scanned and 15 pages for scanned</li>
      <li>Documents cannot exceed 5mb in file size</li>
      <li> You can translate up to 15 separate documents each day</li>
      <!--            <li> Check the Notifications menu to see the progress of your translation</li>-->
    </ul>
  </div>
  <div *ngIf="fileToUpload && pdfSelected" class="p-l-5 m-b-10">
    <mat-checkbox [disabled]="isNotAForm" [(ngModel)]="isFileScanned" (change)="handleCheckbox()">This is a scanned
      document
    </mat-checkbox>
    <mat-checkbox [disabled]="isFileScanned" [(ngModel)]="isNotAForm" (change)="handleCheckbox()">I want enhanced
      translation (may come at a loss to document formatting)
      <i
        class="fal fa-info-circle m-l-5"
        matTooltip=" Orbitax provides enhanced translation accuracy for uploaded documents. Enhanced translation accuracy may come at a loss to document formatting, so it’s recommended that you do not check this option if you are translating a form, table or similar.">
      </i>
    </mat-checkbox>

  </div>
  <div class="flex flex-row justify-between items-center">
    <div class="flex flex-col" style="flex:0 0 48%">
      <mat-form-field appearance="outline" class="w-p-100" style="padding:2px ;">
        <mat-label>From Language *</mat-label>
        <mat-select placeholder="Select a Language" [(ngModel)]="fromLanguage">
          <mat-option *ngFor="let language of taxformsSupportiveLanguage" [value]="language.code">
            {{language.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex flex-col" style="flex: 0 0 48%">
      <mat-form-field appearance="outline" class="w-p-100">
        <mat-label>To Language *</mat-label>
        <mat-select placeholder="Select a Language" [(ngModel)]="toLanguage">
          <mat-option *ngFor="let language of taxformsSupportiveLanguage" [value]="language.code">
            {{language.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>


